import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DevToolsDetectionService } from '../services/dev-tools-detection.service';

/**
 * Redirects to /not-allowed whenever DevTools is detected as open, and blocks
 * any further navigation attempts until it is closed.
 */
export const devToolsGuard: CanActivateFn = () => {
  const devTools = inject(DevToolsDetectionService);
  const router = inject(Router);

  return devTools.blocked() ? router.createUrlTree(['/not-allowed']) : true;
};
